module.exports = __webpack_public_path__ + "assets/img/footer-lg-stiftung.863ed331.svg";